// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
//import { activities } from "../data/activityData";
import { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ActivityItem from "../components/ActivityItem";
import { useSearchParams } from "react-router-dom";

function Activities(props) {
  const [activities, setActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();
  let filterTypeSearchParam = searchParams.get("Ereignisfilter");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/data/activityData.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cache: "no-cache",
    })
      .then(function (originalResponse) {
        return originalResponse.json();
      })
      .then(function (jsonResponse) {
        let jsonRespFiltered = jsonResponse.filter(
          (element) =>
            typeof element.hideInActivityList == "undefined" ||
            element.hideInActivityList === "false"
        );
        let jsonRespWithDate = jsonRespFiltered.map((element) => {
          let dateArray = element.date.match(
            /^(\d{4})\.(\d{2})\.(\d{2})\s*(\d{2})*:*(\d{2})*$/
          );
          element.date = new Date(
            dateArray[1],
            dateArray[2] - 1,
            dateArray[3],
            dateArray[4],
            dateArray[5]
          );
          return element;
        });
        setActivities(jsonRespWithDate);
        setLoadingActivities(false);
      })
      .catch((err) => console.log(err));
  }, []);

  // Using set to filter unique values
  const activityTypes = Array.from(
    new Set(activities.map((activity) => activity.type).sort())
  );

  if (filterTypeSearchParam === null) {
    filterTypeSearchParam = "";
  }
  const [filteredActivities, setFilteredActivities] = useState(activities);
  const [filterType, setFilterType] = useState(filterTypeSearchParam);
  // const [filterDate, setFilterDate] = useState("");

  useEffect(() => {
    setFilteredActivities(
      activities.filter((activity) => {
        return !filterType || filterType === activity.type;
      })
    );
  }, [filterType, activities]);

  const handleFilterTypeChange = (event) => {
    setFilterType(event.target.value);
    if (event.target.value === "") {
      searchParams.delete("Ereignisfilter");
    } else {
      searchParams.set("Ereignisfilter", event.target.value);
    }
    setSearchParams(searchParams);
  };

  return (
    <div>
      <Grid
        container
        sx={(theme) => ({
          [theme.breakpoints.down("sm")]: {
            marginTop: 7,
          },
          [theme.breakpoints.up("sm")]: {
            marginTop: 20,
          },
        })}
        spacing={2}>
        <Grid
          item
          xs={12}>
          <Typography
            variant="h4"
            component="h1"
            textAlign="center">
            Unsere Aktivitäten
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        marginTop={3}>
        <Grid item>
          <FormControl size="small">
            <InputLabel id="filterTypeLabel">Ereignisfilter</InputLabel>
            <Select
              labelId="filterTypeLabel"
              id="filterType"
              value={filterType}
              label="Ereignisfilter"
              sx={{ minWidth: 140 }}
              onChange={handleFilterTypeChange}>
              {activityTypes.map((activityType, i) => {
                return (
                  <MenuItem
                    key={i}
                    value={activityType}>
                    {activityType}
                  </MenuItem>
                );
              })}
              <MenuItem
                key={activityTypes.length}
                value="">
                Alle
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="stretch"
        marginTop={3}>
        {filteredActivities.map((activity, i) => {
          return (
            <Grid
              item
              xs={12}
              md={6}
              key={i}>
              <ActivityItem activityData={activity} />
            </Grid>
          );
        })}
        {loadingActivities === true && (
          <Grid
            item
            xs={12}>
            <Typography variant="body2">
              Aktivitäten werden gerade geladen.
            </Typography>
          </Grid>
        )}
        {loadingActivities === false && activities.length === 0 && (
          <Grid
            item
            xs={12}>
            <Typography variant="body2">
              Keine Aktivitäten vorhanden.
            </Typography>
          </Grid>
        )}
        {activities.length > 0 &&
          filteredActivities.length === 0 &&
          filterType !== "" && (
            <Grid
              item
              xs={12}>
              <Typography variant="body2">
                Keine dem Filter entsprechenden Aktivitäten gefunden.
              </Typography>
            </Grid>
          )}
      </Grid>
    </div>
  );
}

export default Activities;
